import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import Link from 'next/link';
import { cn } from '@/utils';

interface SessionHeaderProps {
  sessionId?: string;
  sessionTitle: string;
  sessionSlug?: string;
  sidebarOpen: boolean;
  onSidebarToggle: () => void;
  hasLoaded: boolean;
  isLoading?: boolean;
}

export default function SessionHeader({
  sessionId,
  sessionTitle,
  sessionSlug,
  sidebarOpen,
  onSidebarToggle,
  hasLoaded,
  isLoading = false,
}: SessionHeaderProps) {
  if (!sessionId) return null;

  return (
    <div
      className={cn(
        'fixed top-0 right-0',
        // On wide screens (>= 1024px), transparent and non-blocking
        'xl:bg-transparent xl:border-none xl:pointer-events-none',
        // On narrow screens (< 1024px), solid background and blocking
        'bg-white dark:bg-gray-900 border-b border-gray-200/50 dark:border-gray-700/50 z-20',
        // Desktop: respect sidebar, Mobile: full width
        sidebarOpen ? 'md:left-[260px] left-0' : 'md:left-12 left-0',
        hasLoaded && 'transition-[left] duration-200'
      )}
    >
      <div className="flex items-center justify-between px-5 py-5">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={onSidebarToggle}
            className="md:hidden hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg pointer-events-auto"
          >
            <Menu className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          </Button>

          <div className="flex items-center gap-2 pointer-events-auto">
            <h1
              className={cn(
                'text-lg font-semibold text-gray-800 dark:text-gray-200',
                // On wide screens, add a subtle background to the title only
                'lg:backdrop-blur-sm lg:px-3 lg:rounded-lg'
              )}
            >
              <Link href={`/chats/${sessionSlug}`}>{sessionTitle}</Link>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
